/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpIcon16Light = forwardRef('ArrowShapeAUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.117 1.427a1.25 1.25 0 0 1 1.768 0l5.866 5.866c.63.63.184 1.707-.707 1.707H12v4.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5V9H1.958C1.067 9 .62 7.923 1.25 7.293l5.867-5.866Zm1.06.707a.25.25 0 0 0-.353 0L1.958 8H4.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 1 .5-.5h2.544L8.178 2.134Z" })));
});
